<template>
  <div
    class="rs-list-group"
    :class="{ flush: flush, horizontal: horizontal }"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsListGroup',

  props: {
    /**
      * Renders a flush list group with no left and right borders.
      */
    flush: {
      type: Boolean,
      default: false,
    },
    /**
      *  Renders the list-group horizontally. The default is vertical.
      */
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
  @import '@/styles/_variables.scss';
  .rs-list-group{
    display: flex;
    flex-direction: column;
    .rs-list-group-item{
      &:first-child{
        border-radius: $global-radius $global-radius 0 0;
      }
      &:last-child{
        border-radius: 0 0 $global-radius $global-radius;
        border-bottom: 1px solid $extra-light-gray;
      }
    }
    &.flush{
      .rs-list-group-item{
        border-right: 0;
        border-left: 0;
        border-radius: 0;
      }
    }
    &.horizontal{
      flex-direction: row;
      .rs-list-group-item{
        margin-right: -1px;
        margin-bottom: 0;
        &:first-child{
          border-radius: $global-radius 0 0 $global-radius;
        }
        &:last-child{
          border-radius: 0 $global-radius $global-radius 0;
        }
      }
    }
  }

  .rs-card{
    .rs-card__header + .rs-list-group.flush{
      .rs-list-group-item:first-child{
        border-top: 0;
      }
    }
  }
</style>
